import { z } from "zod";
import { roleSchema } from "./codes.js";
/** The authenticated user, as returned by `GET /api/auth/me`. */
export const currentUserSchema = z.object({
    subject: z.string(),
    name: z.string().nullable(),
    roles: z.array(roleSchema),
});
//# sourceMappingURL=auth.js.map